import Icon from '../components/Icon.vue'

Icon.register({
  pray: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M256 128C291.4 128 320 99.4 320 64S291.4 0 256 0 192 28.6 192 64 220.7 128 256 128zM225.4 297.8C239.4 314.5 264.4 316.8 281.3 303L369.3 230.9C386.4 217 388.9 191.8 375 174.7 361 157.6 335.8 155.1 318.7 169.1L261.2 216.1 222.3 169.7C206.9 151.4 183.1 141.8 158.3 144.4 134.1 146.9 113.1 160.7 101.9 181.3L52.6 273.4C29.2 317 43.9 369.7 86.8 397.1L131.6 432H40C17.9 432 0 449.9 0 472S17.9 512 40 512H248C282.1 512 301.8 469.2 276.3 443.7L166.4 333.9 201.2 269 225.4 297.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pray.js
// module id = B1nJ
// module chunks = 144